import API from "api/client";
import { envConfig } from "config";

const { sysadminSolrAPI } = envConfig;

const getSolrIndexStatus = () => {
  return API.get(`${sysadminSolrAPI}status`).then((res) => res.data);
};

const refreshSolrIndexes = () => {
  return API.put(`${sysadminSolrAPI}refresh`).then((res) => res.data);
};

export default {
  getIndexStatus: getSolrIndexStatus,
  refreshIndex: refreshSolrIndexes,
};
